export default __webpack_public_path__ + "static/media/gears.199dde98.png";